import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ExternalLinkIcon } from 'lucide-react';
interface CaseStudyCardProps {
  slug: string;
  title: string;
  description: string;
  relevance: number;
  thumbnail: string;
  onClick: () => void;
}
export function CaseStudyCard({
  slug,
  title,
  description,
  relevance,
  thumbnail,
  onClick
}: CaseStudyCardProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('🎯 Case study card clicked:', slug);
    console.log('🎯 onClick function:', onClick);
    onClick();
  };
  return <motion.button initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} onClick={handleClick} onTouchEnd={handleClick} className="w-full bg-white/5 border border-white/20 rounded-lg overflow-hidden hover:border-white/40 hover:bg-white/10 transition-all duration-300 text-left group cursor-pointer" style={{
    position: 'relative',
    zIndex: 50,
    pointerEvents: 'auto',
    touchAction: 'manipulation'
  }} data-id="element-62">
      <div className="flex flex-col sm:flex-row gap-3 p-3 sm:p-4" style={{
      pointerEvents: 'none'
    }} data-id="element-63">
        {/* Mobile Header: Title & Relevance */}
        <div className="flex sm:hidden items-start justify-between gap-2 w-full" data-id="element-64">
          <h4 className="text-white font-medium text-sm line-clamp-1" data-id="element-65">
            {title}
          </h4>
          <span className="flex-shrink-0 text-xs bg-white/10 text-white/80 px-2 py-1 rounded-full" data-id="element-66">
            {Math.round(relevance * 100)}% match
          </span>
        </div>

        {/* Thumbnail - FIXED: Smaller on mobile (h-24 instead of h-48) */}
        <div className="w-full h-24 sm:w-24 sm:h-24 flex-shrink-0 rounded-lg overflow-hidden bg-white/5" data-id="element-67">
          <img src={thumbnail} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" style={{
          pointerEvents: 'none'
        }} data-id="element-68" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0 flex flex-col" data-id="element-69">
          {/* Desktop Header: Title & Relevance */}
          <div className="hidden sm:flex items-start justify-between gap-2 mb-2" data-id="element-70">
            <h4 className="text-white font-medium text-sm line-clamp-1" data-id="element-71">
              {title}
            </h4>
            <span className="flex-shrink-0 text-xs bg-white/10 text-white/80 px-2 py-1 rounded-full" data-id="element-72">
              {Math.round(relevance * 100)}% match
            </span>
          </div>

          <p className="text-white/60 text-xs line-clamp-2 mb-2 sm:mb-3" data-id="element-73">
            {description}
          </p>
          <div className="flex items-center gap-1 text-white/80 text-xs group-hover:text-white transition-colors mt-auto" data-id="element-74">
            <span data-id="element-75">View project</span>
            <ArrowRightIcon className="w-3 h-3 transition-transform group-hover:translate-x-1" data-id="element-76" />
          </div>
        </div>
      </div>
    </motion.button>;
}